<template>
  <button
    class="scroll-to-content-button"
    type="button"
    v-show="hasContent"
    @click="scrollToContent"
  >
    {{ text }}
  </button>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import * as scrollToElement from 'scroll-to-element';
  import {intersectionService} from '../../utilities/js/intersectionService/intersectionService';

  @Options({
    name: 'scroll-to-content-button'
  })
  export default class ScrollToContentButton extends Vue {
    @Prop()
    text: string;

    @Prop()
    contentSelector: string;

    hasContent: boolean = false;
    content: unknown;

    mounted() {
      this.content = document.querySelector(this.contentSelector);
      if (this.content) {
        this.hasContent = true;
      }
    }

    scrollToContent() {
      const offsetTop = document.querySelector('.header__sticky--active')?.clientHeight || 0;
      const tween = scrollToElement(this.content, {duration: 500, offset: -offsetTop});
      intersectionService.disable();
      tween.on('end', () => {
        setTimeout(() => {
          intersectionService.enable();
          intersectionService.activateAll('lazyload');
        }, 200);

        // scroll fix, lazy-load images just loaded and the scroll position is not correct
        setTimeout(() => {
          const offsetTopOnEnd = this.content instanceof HTMLElement ? Math.round(this.content.getBoundingClientRect().top) : 0;
          // If the content is not in the viewport, scroll to it again
          if (Math.abs(offsetTopOnEnd - offsetTop) > 10) {
            scrollToElement(this.content, {duration: 200, offset: -offsetTop});
          }

        }, 1000);
      });
    }
  }
</script>
